import { useState } from 'react';

import ContactUsForm from 'pages/Dialogs/ContactUsForm';
import { useAnimateOnView } from 'customHooks/useAnimateOnView';
import useTranslation from 'customHooks/translate';

import { fadeInUp } from './landing-motion';

const icons: Record<string, JSX.Element> = {
  key: (
    <img
      key="key-icon"
      src="assets/hero-key.svg"
      alt="key"
      className="inline-block h-[0.85em] w-[0.85em] object-contain align-middle"
    />
  ),
  check: (
    <img
      key="check-icon"
      src="assets/hero-check.svg"
      alt="check"
      className="inline-block h-[0.85em] w-[0.85em] object-contain align-middle"
    />
  ),
};

function parseWithIcons(text: string): (string | JSX.Element)[] {
  const parts = text.split(/(\{key\}|\{check\})/);
  return parts.map((part) => {
    const match = part.match(/^\{(\w+)\}$/);
    if (match) return icons[match[1]] ?? part;
    return part;
  });
}

const SecondaryFooter = () => {
  const translation = useTranslation();
  const { ref, visible } = useAnimateOnView();
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);

  return (
    <section
      ref={ref}
      id="contact"
      className="mt-[48px] px-[16px] md:px-[56px]"
    >
      <div className="relative flex flex-wrap justify-between bg-[rgba(41,45,50,1)] px-[20px] py-[32px] md:px-[48px] md:py-[100px]">
        <div
          className={`flex flex-col gap-[24px] ${
            visible ? fadeInUp : 'opacity-0'
          }`}
          style={{ animationDelay: visible ? '0.06s' : undefined }}
        >
          <h1 className="text-[24px] font-bold leading-[1] text-white md:text-[40px]">
            Invoice Reporter
          </h1>
          <div className="text-left text-[18px] font-normal leading-tight text-white opacity-70 lg:max-w-[400px] xl:max-w-[unset]">
            {parseWithIcons(
              translation.home.ProductParagraph.ProductParagraphText
            )}
          </div>
          <button
            onClick={() => setIsContactFormOpen(true)}
            className="w-max rounded-full bg-white px-6 py-3 text-sm font-medium text-[rgba(41,45,50,1)] transition-all duration-300 hover:-translate-y-[2px] hover:bg-[rgba(255,255,255,0.94)] hover:shadow-[0_10px_24px_rgba(0,0,0,0.2)] active:translate-y-0 sm:px-8 sm:py-3 sm:text-base md:px-10 md:py-4"
          >
            {translation.checkEmail.ContactLink}
          </button>
        </div>
        <img
          src="assets/footer-document.svg"
          alt="footer"
          className={`absolute right-[-10px] top-[-10px] hidden h-[400px] w-auto lg:block ${
            visible ? fadeInUp : 'opacity-0'
          }`}
          style={{ animationDelay: visible ? '0.14s' : undefined }}
        />
      </div>
      <ContactUsForm
        open={isContactFormOpen}
        handleClose={() => setIsContactFormOpen(false)}
      />
    </section>
  );
};

export default SecondaryFooter;
